export default class MultiLanguageMap {

    public readObject(obj: object, targetKey: string): void {
        const targetKeyLength: number = targetKey.length;
        Object.keys(obj).forEach(objectKey => {
            if(objectKey.indexOf(targetKey) !== 0) {
                return;
            }

            const language: string = objectKey.substring(targetKeyLength, objectKey.length).toLowerCase();
            this[language] = obj[objectKey];
        });
    }

}